"use client";

import _objectSpread from "E:\\Himanshu\\EducationWorld_Current\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "E:\\Himanshu\\EducationWorld_Current\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import classNames from 'classnames';
import * as React from 'react';
import { useBootstrapPrefix } from './ThemeProvider';
import { jsx as _jsx } from "react/jsx-runtime";
var Spinner = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
    variant = _ref.variant,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? 'border' : _ref$animation,
    size = _ref.size,
    _ref$as = _ref.as,
    Component = _ref$as === void 0 ? 'div' : _ref$as,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, ["bsPrefix", "variant", "animation", "size", "as", "className"]);
  bsPrefix = useBootstrapPrefix(bsPrefix, 'spinner');
  var bsSpinnerPrefix = "".concat(bsPrefix, "-").concat(animation);
  return /*#__PURE__*/_jsx(Component, _objectSpread({
    ref: ref
  }, props, {
    className: classNames(className, bsSpinnerPrefix, size && "".concat(bsSpinnerPrefix, "-").concat(size), variant && "text-".concat(variant))
  }));
});
Spinner.displayName = 'Spinner';
export default Spinner;